import {RSValidationHelper} from './validation';


export class RSFormHelper
{
	/**
	 * @param {HTMLFormElement} elForm
	 * @param {string} format - Output format (json|string)
	 * @param {boolean} includeChildrenForms
	 * @returns {Object|string}
	 */
	static serialize(elForm, format = 'json', includeChildrenForms = false)
	{
		const serialized = (format === 'json') ? {} : [];
		const elements = Array.from(elForm.elements); // Je le passe en Array
		
		if (includeChildrenForms)
		{
			const elsChildrenForms = elForm.querySelectorAll('form');
			
			if (elsChildrenForms.length > 0)
			{
				for (const elChildForm of elsChildrenForms)
				{
					elements.push(...elChildForm.elements);
				}
			}
		}
		
		for (let i = 0; i < elements.length; i++)
		{
			const elField = elements[i];

			if (!elField.name || elField.disabled || (elField.type === 'file') || (elField.type === 'reset') || (elField.type === 'submit') || (elField.type === 'button')) continue;

			if (elField.type === 'select-multiple')
			{
				let values = [];
				
				for (let j = 0; j < elField.options.length; j++)
				{
					if (!elField.options[j].selected) continue;

					/*if (format === 'json')
					{
						serialized[elField.name] = elField.options[j].value;
					}
					else
					{
						serialized.push(encodeURIComponent(elField.name) + "=" + encodeURIComponent(elField.options[j].value));
					}*/
					
					values.push(elField.options[j].value);
				}
				
				if (values.length > 0)
				{
					if (format === 'json')
					{
						serialized[elField.name] = values;
					}
					else
					{
						for (const value of values)
						{
							serialized.push(encodeURIComponent(elField.name) + "=" + encodeURIComponent(value));
						}
						
						//serialized.push(encodeURIComponent(elField.name) + "=" + encodeURIComponent(values.join(',')));
					}
				}
				
				values = null;
			}
			else if (((elField.type !== 'checkbox') && (elField.type !== 'radio')) || elField.checked)
			{
				if (format === 'json')
				{
					if (elField.name.indexOf('[]') === -1)
					{
						serialized[elField.name] = elField.value;
					}
					else
					{
						const fieldName = elField.name.substr(0, (elField.name.length - 2));
						
						if (typeof serialized[fieldName] === 'undefined')
						{
							serialized[fieldName] = [elField.value];
						}
						else
						{
							serialized[fieldName].push(elField.value);
						}
					}
				}
				else
				{
					// TODO: Gérer les valeurs multiples (voir ci-dessus)
					
					serialized.push(encodeURIComponent(elField.name) + "=" + encodeURIComponent(elField.value));
				}
			}
		}

		return (format === 'json') ? serialized : serialized.join('&');
	}


	/**
	 * @param {FormData} formData
	 * @param {boolean} renameArrays
	 * @returns {Object}
	 */
	static jsonifyFormData(formData, renameArrays = true)
	{
		const json = {};

		for (const pair of formData.entries())
		{
			let key = pair[0];
			const value = pair[1];

			if (key.indexOf('[]') === -1)
			{
				if (!(value instanceof File) && ((typeof value.constructor === 'undefined') || (value.constructor !== File)))
				{
					json[key] = value;
				}
				else if((typeof value['name'] !== 'undefined') && (value['name'] !== ''))
				{
					json[key] = value;
				}
			}
			else
			{
				if (renameArrays) key = key.substring(0, (key.length - 2));

				if (typeof json[key] === 'undefined') json[key] = [];
				json[key].push(value);
			}
		}

		return json;
	}


	/**
	 * @param {string} inputName
	 * @param {HTMLElement} elContainer
	 * @param {boolean} onlyChecked
	 * @returns {?Array}
	 */
	static getInputArrayValues(inputName, elContainer = null, onlyChecked = false)
	{
		let selector = `input[name="${inputName}"]`;
		if (onlyChecked) selector += ':checked';

		const elsInputs = (elContainer == null) ? document.querySelectorAll(selector) : elContainer.querySelectorAll(selector);
		let values;

		if (elsInputs.length > 0)
		{
			values = [];

			for (let i = 0; i < elsInputs.length; i++)
			{
				values[i] = elsInputs[i].value; // Info : "values[i]" est plus performant que "values.push()"
			}
		}
		else
		{
			values = null;
		}

		return values;
	}


	/**
	 * @param {HTMLSelectElement} elSelect
	 * @param {boolean} onlySelected
	 * @returns {Array}
	 */
	static getMultipleSelectArrayValues(elSelect, onlySelected = false)
	{
		if (onlySelected) return [...elSelect.selectedOptions].map(option => option.value);
		else return [...elSelect.options].map(option => option.value);
	}


	/**
	 * @param {HTMLElement} elContainer
	 * @param {?Object} data
	 * @param {?Array} skippedNames
	 * @param {?string} validationTargetSelector
	 * @param {string} validClass
	 * @param {string} invalidClass
	 * @returns {boolean}
	 */
	static checkRequired(elContainer, data = null, skippedNames = null, validationTargetSelector = null, validClass = 'is-valid', invalidClass = 'is-invalid')
	{
		let success = true;

		const elsRequireds = elContainer.querySelectorAll('[required]');
		
		for (const elField of elsRequireds)
		{
			const name = elField.getAttribute('name');
			
			if ((skippedNames != null) && (skippedNames.length > 0))
			{
				let skip = false;
				
				for (let i = 0; i < skippedNames.length; i++)
				{
					if (skippedNames[i] === name)
					{
						skip = true;
						break;
					}
				}
				
				if (skip) continue;
			}

			let value;

			if (data == null)
			{
				if ((elField.type !== 'checkbox') && (elField.type !== 'radio')) value = elField.value;
				else value = elField.checked ? elField.value : null;
			}
			else
			{
				value = data.hasOwnProperty(name) ? data[name] : null;
			}

			if ((value !== null) && (value instanceof File || ((typeof value.constructor !== 'undefined') && (value.constructor === File))))
			{
				value = value.name;
			}
			
			const elValidationTarget = (validationTargetSelector != null) ? elField.closest(validationTargetSelector) : elField;
			
			if ((value === null) || (value === ''))
			{
				if (success) success = false;

				RSFormHelper.addValidationClassToField((elValidationTarget != null) ? elValidationTarget : elField, false, false, validationTargetSelector, validClass, invalidClass);
			}
			else
			{
				// Je ne mets la class que si le champ était "invalid" avant pour ne pas avoir des "check" partout

				RSFormHelper.addValidationClassToField((elValidationTarget != null) ? elValidationTarget : elField, true, true, validationTargetSelector, validClass, invalidClass);
			}
		}

		return success;
	}


	/**
	 * @param {HTMLElement} elContainer
	 * @param {?Object} data
	 * @param {string} selector
	 * @param {?string} validationTargetSelector
	 * @param {string} validClass
	 * @param {string} invalidClass
	 * @returns {boolean}
	 */
	static checkEmails(elContainer, data = null, selector = 'input[type="email"]', validationTargetSelector = null, validClass = 'is-valid', invalidClass = 'is-invalid')
	{
		let success = true;

		const elsEmails = elContainer.querySelectorAll(selector);

		for (const elField of elsEmails)
		{
			const name = elField.getAttribute('name');

			let value;

			if (data == null)
			{
				value = elField.value;
			}
			else
			{
				value = data.hasOwnProperty(name) ? data[name] : null;
			}
			
			const elValidationTarget = (validationTargetSelector != null) ? elField.closest(validationTargetSelector) : elField;

			if ((value === null) || (value === '') || !RSValidationHelper.isEmailValid(value))
			{
				if (success) success = false;

				RSFormHelper.addValidationClassToField((elValidationTarget != null) ? elValidationTarget : elField, false, false, validationTargetSelector, validClass, invalidClass);
			}
			else
			{
				// Je ne mets la class que si le champ était "invalid" avant pour ne pas avoir des "check" partout

				RSFormHelper.addValidationClassToField((elValidationTarget != null) ? elValidationTarget : elField, true, true, validationTargetSelector, validClass, invalidClass);
			}
		}

		return success;
	}


	/**
	 * @param {HTMLElement} elField
	 * @param {boolean} isValid
	 * @param {boolean} onlyIfHasValidation
	 * @param {?string} validationTargetSelector
	 * @param {string} validClass
	 * @param {string} invalidClass
	 */
	static addValidationClassToField(elField, isValid, onlyIfHasValidation, validationTargetSelector = null, validClass = 'is-valid', invalidClass = 'is-invalid')
	{
		let elValidationTarget = (validationTargetSelector != null) ? elField.closest(validationTargetSelector) : elField;
		if (elValidationTarget == null) elValidationTarget = elField;
		
		if (isValid)
		{
			if (onlyIfHasValidation && !elValidationTarget.classList.contains(invalidClass)) return;

			if (elValidationTarget.classList.contains(invalidClass)) elValidationTarget.classList.remove(invalidClass);
			if (!elValidationTarget.classList.contains(validClass)) elValidationTarget.classList.add(validClass);
		}
		else
		{
			if (onlyIfHasValidation && !elValidationTarget.classList.contains(validClass)) return;

			if (elValidationTarget.classList.contains(validClass)) elValidationTarget.classList.remove(validClass);
			if (!elValidationTarget.classList.contains(invalidClass)) elValidationTarget.classList.add(invalidClass);
		}
	}


	/**
	 * @param {HTMLElement} elField
	 * @param {boolean} onlyIfHasValidation
	 * @param {?string} validationTargetSelector
	 * @param {string} validClass
	 * @param {string} invalidClass
	 */
	static removeValidationClassToField(elField, onlyIfHasValidation, validationTargetSelector = null, validClass = 'is-valid', invalidClass = 'is-invalid')
	{
		let elValidationTarget = (validationTargetSelector != null) ? elField.closest(validationTargetSelector) : elField;
		if (elValidationTarget == null) elValidationTarget = elField;
		
		if (onlyIfHasValidation && !elValidationTarget.classList.contains(validClass) && !elValidationTarget.classList.contains(invalidClass)) return;

		if (elValidationTarget.classList.contains(validClass)) elValidationTarget.classList.remove(validClass);
		else if (elValidationTarget.classList.contains(invalidClass)) elValidationTarget.classList.remove(invalidClass);
	}


	/**
	 * @param {HTMLElement} elForm
	 */
	static removeAllInvalidFeedbacks(elForm)
	{
		const elsInvalidFeedbacks = elForm.querySelectorAll('.invalid-feedback');

		if (elsInvalidFeedbacks.length > 0)
		{
			elsInvalidFeedbacks.forEach((elInvalidFeedback) => {
				elInvalidFeedback.parentNode.removeChild(elInvalidFeedback);
			});
		}
	}


	/**
	 * @param {HTMLElement} elForm
	 * @param {string} validClass
	 * @param {string} invalidClass
	 */
	static removeAllValidationClasses(elForm, validClass = 'is-valid', invalidClass = 'is-invalid')
	{
		const elsIsValids = elForm.querySelectorAll(`.${validClass}`);

		if (elsIsValids.length > 0)
		{
			elsIsValids.forEach((elIsValid) => {
				elIsValid.classList.remove(validClass);
			});
		}

		const elsIsInvalids = elForm.querySelectorAll(`.${invalidClass}`);

		if (elsIsInvalids.length > 0)
		{
			elsIsInvalids.forEach((elIsInvalid) => {
				elIsInvalid.classList.remove(invalidClass);
			});
		}
	}


	/**
	 * @param {HTMLElement} elForm
	 * @param {Object} errors
	 * @param {?string} validationTargetSelector
	 * @param {string} validClass
	 * @param {string} invalidClass
	 */
	static displayErrors(elForm, errors, validationTargetSelector = null, validClass = 'is-valid', invalidClass = 'is-invalid')
	{
		RSFormHelper.removeAllInvalidFeedbacks(elForm);

		for (const key of Object.keys(errors))
		{
			RSFormHelper.displayError(elForm, key, errors[key], validationTargetSelector, validClass, invalidClass);
		}
	}


	/**
	 * @param {HTMLElement} elForm
	 * @param {string} fieldName
	 * @param {string} error
	 * @param {?string} validationTargetSelector
	 * @param {string} validClass
	 * @param {string} invalidClass
	 */
	static displayError(elForm, fieldName, error, validationTargetSelector = null, validClass = 'is-valid', invalidClass = 'is-invalid')
	{
		const elField = elForm.querySelector(`[name="${fieldName}"]`);

		if (elField != null)
		{
			const elValidationTarget = (validationTargetSelector != null) ? elField.closest(validationTargetSelector) : elField;
			
			RSFormHelper.addValidationClassToField((elValidationTarget != null) ? elValidationTarget : elField, false, false, validationTargetSelector, validClass, invalidClass);

			elField.parentNode.insertAdjacentHTML('beforeend', `<span class="invalid-feedback" style="display:block;">${error}</span>`);
		}
	}


	/**
	 * @param {HTMLElement} elForm
	 * @param {string} validClass
	 * @param {string} invalidClass
	 */
	static reset(elForm, validClass = 'is-valid', invalidClass = 'is-invalid')
	{
		let form, wrapped;

		if(elForm.tagName.toLowerCase() === 'form')
		{
			form = elForm;
			wrapped = false;
		}
		else
		{
			form = document.createElement('form');

			elForm.parentNode.insertBefore(form, elForm);
			form.appendChild(elForm);

			wrapped = true;
		}

		form.reset();

		RSFormHelper.removeAllInvalidFeedbacks(form);
		RSFormHelper.removeAllValidationClasses(form, validClass, invalidClass);

		if (wrapped)
		{
			form.parentNode.insertBefore(elForm, form);
			form.parentNode.removeChild(form);

			form = null;
		}
	}


	/**
	 * @param {HTMLElement} elCheckbox
	 * @param {boolean} checked
	 */
	static setCheckboxChecked(elCheckbox, checked)
	{
		elCheckbox.removeAttribute('indeterminate');
		elCheckbox.indeterminate = false;

		if (checked) elCheckbox.setAttribute('checked', 'checked');
		else elCheckbox.removeAttribute('checked');

		elCheckbox.checked = checked;
	}


	/**
	 * @param {HTMLElement} elCheckbox
	 * @param {boolean} indeterminate
	 */
	static setCheckboxIndeterminate(elCheckbox, indeterminate)
	{
		elCheckbox.removeAttribute('checked');
		elCheckbox.checked = false;

		if (indeterminate) elCheckbox.setAttribute('indeterminate', 'indeterminate');
		else elCheckbox.removeAttribute('indeterminate');

		elCheckbox.indeterminate = indeterminate;
	}


	/**
	 * @param {HTMLFormElement} elForm
	 */
	static uncheckAll(elForm)
	{
		const elsChecked = elForm.querySelectorAll(':checked');

		if (elsChecked.length > 0)
		{
			for (const elChecked of elsChecked)
			{
				RSFormHelper.setCheckboxChecked(elChecked, false);
			}
		}
	}
	
	
	/**
	 * @param {HTMLSelectElement} elSelect
	 * @param {string|number} value
	 */
	static setSelectValue(elSelect, value)
	{
		const elSelectedOption = elSelect.querySelector(`option[value="${value}"]`);
		if (elSelectedOption != null) elSelect.selectedIndex = elSelectedOption.index;
	}


	/**
	 * @param {?HTMLFormElement} elForm
	 */
	static preventSubmitOnEnterKey(elForm = null)
	{
		if (elForm != null)
		{
			elForm.addEventListener('keypress', (event) => {
				if ((event.keyCode === 13) && (event.target.tagName.toLowerCase() !== 'textarea'))
				{
					event.preventDefault();
					return false;
				}
			});
			
			/*const elsInputs = elForm.querySelectorAll('input');
			
			if (elsInputs.length > 0)
			{
				for (const elInput of elsInputs)
				{
					elInput.addEventListener('keypress', (event) => {
						if (event.keyCode === 13)
						{
							event.preventDefault();
							return false;
						}
					});
				}
			}*/
		}
		else
		{
			document.addEventListener('keypress', (event) => {
				if ((event.keyCode === 13) && (event.target.tagName.toLowerCase() !== 'textarea'))
				{
					event.preventDefault();
					return false;
				}
			});
		}
	}


	/**
	 * @param {HTMLFormElement} elForm
	 * @param {Object} data
	 */
	static fillForm(elForm, data)
	{
		for (const [key, value] of Object.entries(data))
		{
			const elControl = elForm.querySelector(`[name="${key}"]`);

			if (elControl != null)
			{
				switch (elControl.tagName.toLowerCase())
				{
					case 'input' :

						switch (elControl.getAttribute('type'))
						{
							case 'checkbox' :
							case 'radio' :

								const elValue = elForm.querySelector(`[name="${key}"][value="${value}"]`);

								if (elValue != null)
								{
									RSFormHelper.setCheckboxChecked(elValue, true);
								}

								break;

							default :
								elControl.value = value;
								break;
						}

						break;

					case 'textarea' :
						elControl.value = value;
						break;

					case 'select' :
						RSFormHelper.setSelectValue(elControl, value);
						break;
				}
			}
		}
	}
}
